import { useLayoutEffect, useRef, useState } from 'react';
import { consumeBetslipAnimationOrigin, type BetslipAnimationOrigin } from '../utils/betslipAnimationOrigin';

type FlyAnimation = {
  key: number;
  origin: BetslipAnimationOrigin;
  target: BetslipAnimationOrigin;
} | null;

const FLY_ANIMATION_MS = 420;

export const useBetslipFlyAnimation = (betslipCount: number, enabled = true) => {
  const previousCountRef = useRef(betslipCount);
  const badgeRef = useRef<HTMLDivElement | null>(null);
  const [countAnimationKey, setCountAnimationKey] = useState(0);
  const [flyAnimation, setFlyAnimation] = useState<FlyAnimation>(null);

  useLayoutEffect(() => {
    const previousCount = previousCountRef.current;

    if (enabled && betslipCount > previousCount) {
      const nextAnimationKey = countAnimationKey + 1;
      setCountAnimationKey(nextAnimationKey);

      const origin = consumeBetslipAnimationOrigin();
      const badgeRect = badgeRef.current?.getBoundingClientRect();

      if (origin && badgeRect) {
        setFlyAnimation({
          key: nextAnimationKey,
          origin,
          target: {
            x: badgeRect.left + badgeRect.width / 2,
            y: badgeRect.top + badgeRect.height / 2,
          },
        });

        const timeout = window.setTimeout(() => {
          setFlyAnimation(null);
        }, FLY_ANIMATION_MS);

        return () => {
          window.clearTimeout(timeout);
        };
      }
    }

    previousCountRef.current = betslipCount;
    return undefined;
  }, [betslipCount, countAnimationKey, enabled]);

  return {
    badgeRef,
    flyAnimation,
  };
};
